// extracted by mini-css-extract-plugin
export default {"smoothly_appear":"home_smoothly_appear__FGEWg","smoothly-appear":"home_smoothly-appear__ppsKX","main":"home_main__szT0-"};